"use strict";
var React = require('react');
var Link = require('react-router');
var ListNewsComponent = require('./ListNewsComponent');
var LanguageStore = require('../../store/LanguageStore')
var getAdAction = require('../../actions/getAdAction');
var Navigation = require('../Navigation/Navigation')
var Slider = require('./Slider');
var DocMeta = require('react-doc-meta');

var Pocetna = React.createClass({
  componentDidMount() {
      LanguageStore.addChangeListener(this.onChange);
    },
    getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
    componentWillUnmount() {
      LanguageStore.removeChangeListener(this.onChange);
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);
    },
  slider(){
    return(
      <div>
        <Slider {...this.props} />
      </div>
    )
  },
  opisSrb(){
    return(
           <div>
              <div className='container'>
                <div className='index-content col-md-12 clearfix content-heading pull-left'>
                  <div className='col-md-6 text-center'>
                     <img className="pocetna-img" src="css/Heder-01.png" alt='Logo Termovent SC Livnica čelika AD'/>
                  </div>
                  <div className="col-md-6">
                    <p>
                    Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika. Svoje proizvode plasira sa podjednakim uspehom kako na domaćem, tako i na inostranom tržištu.
                    </p>
                    <p>
                    Davne 1963. godine Livnica je poslovala u sastavu velikog metalurškog kompleksa "Jelšingrad" iz Banja Luke. Godine 1998. među prvima je transformisana u akcionarsko društvo, a 2003. godine, u procesu privatizacije, D.O.O. "Termovent SC" iz Temerina postao je najznačajniji strateški partner Livnice i njen većinski vlasnik.
                    </p>
                    <p>
                    U vlasničkoj strukturi Termovent SC Livnica čelika AD fizička lica učestvuju sa 33.46%, a pravna lica sa 66.54% od čega je 60.10% osnovnog kapitala u vlasništvu D.O.O. "Termovent SC". Sve akcije livnice uključene su u trgovanje na MTP Belex.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            )
  },
  opisEng(){
    return(
             <div>
                <div className='container'>
                  <div className='index-content col-md-12 clearfix content-heading pull-left'>
                    <div className='col-md-6 text-center'>
                       <img className="pocetna-img" src="css/Heder-01.png" alt='Logo of Termovent SC Steel foundry J.S.C'/>
                    </div>
                    <div className="col-md-6">
                      <p>
                      Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of steel castings and employs about 200 workers.
                      </p>
                      <p>
                      Back in 1963, the foundry was a part of the large metallurgical complex "Jelšingrad" from Banja Luka and in 1998 was the one of the first to be transformed into a joint stock company. During the privatization process in 2001, Ltd "Termovent SC" Temerin became the most important strategic partner of the foundry and its majority owner.
                      </p>
                      <p>
                      In the ownership structure of Termovent SC Steel foundry J.S.C natural persons participate with 33.46% and legal entities with 66.54%  and 60.10% of those are in the ownership of the LLC "Termovent SC". All shares of the foundry are included in trading on the MTF (Multilateral Trading Facility) Belex
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              )
  },
  opisGer(){
    return(
           <div>
              <div className='container'>
                <div className='index-content col-md-12 clearfix content-heading pull-left'>
                  <div className='col-md-6 text-center'>
                     <img className="pocetna-img" src="css/Heder-01.png" />
                  </div>
                  <div className="col-md-6">
                    <p>
                    Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte. Die Fabrik ist nicht nur im Binnenmarkt sondern auch im Auslandsmarkt sehr erfolgreich.
                    </p>
                    <p>
                    Seit ihrer Gründung  im Jahr 1963 war die Stahlfabrik ein Teil des großen metallurgischen Fabrikkomplexes „Jelsingrad“ aus Banja Luka. 1998 war die Stahlfabrik eine der ersten Firmen, die in eine Aktiengesellschaft transormiert wurde.  Seit des Pravitisierungsprozesses im Jahr 2001 ist der Termovent SC Temerin der wichtigste  geschäftsstrategische Partner und  großter Teilinhaber der Stahlfabrik geworden.
                    </p>
                    <p>
                    Die Eigentümerstruktur besagt, dass natürliche Personen mit 33,46% und Rechtsträger mit 66, 54% (von dessen GmbH Termovent SC mit 60,10%) partizipiert werden. Alle Aktien von Die Stahlfabrik sind im Handel des multilateralen Handelssystems Belex inkludiert.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            )
  },
  novosti(){
    return(
    <div className='container'>
      <h2>Novosti</h2>
      <div className="col-md-6">
      <ListNewsComponent listType='ad'  title='AKCIONARSKO DRUŠTVO' limit='6'/>
      </div>
      <div className="col-md-6">
      <ListNewsComponent listType='god_izv'  title='VAŽNA DOKUMENTA' limit='6'/>
      </div>
    </div>
    )
  },
  render() {
    var titleSrb = 'Termovent SC Livnica čelika A.D. Bačka Topola';
    var titleEng = 'Termovent SC Steal foundry J.S.C Backa Topola'
    var titleGer = 'Die Termovent SC Stahlfabrik GmbH';
      var tagsSrb = [
      {name: "description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {name: "keyword", content: "Termovent,celik,livnica,odlivak,menadzment,backa topola,srbija"},
      {itemProp: "name", content: "Početna | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {itemProp: "description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:title", content: "Početna | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {name: "twitter:creator", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Početna | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {property: "og:site_name", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
    ];
    var tagsEng = [
      {name: "description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {name: "keyword", content: "Termovent SC,Steel,foundry,Steel casting,production,backa topola, serbia"},
      {itemProp: "name", content: "Home | Termovent SC Steal foundry A.D. Backa Topola"},
      {itemProp: "description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {itemProp: "image", content: "http://www.livnica.com/img/slik1.jpg"},
      {name: "twitter:title", content: "Home | Termovent SC Steal foundry A.D. Backa Topola"},
      {name: "twitter:description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {name: "twitter:creator", content: "Termovent SC Steel foundry"},
      {name: "twitter:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Home | Termovent SC Steal foundry A.D. Backa Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {property: "og:site_name", content: "Termovent SC Steel foundry J.S.C"},
    ];
    var tagsGer = [
      {name: "description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {name: "keyword", content: "Termovent SC,Stahlfabrik,Stahlgusse,über uns, Serbien"},
      {itemProp: "name", content: "Startsite | Die Termovent SC Stahlfabrik GmbH"},
      {itemProp: "description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {itemProp: "image", content: "http://www.livnica.com/img/slik1.jpg"},
      {name: "twitter:card", content: "product"},
      {name: "twitter:site", content: "@publisher_handle"},
      {name: "twitter:title", content: "Startsite"},
      {name: "twitter:description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {name: "twitter:creator", content: "Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Startsite"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {property: "og:site_name", content: "Die Termovent SC Stahlfabrik GmbH"},
    ];
    document.title = this.state.lang === 'uk' ? titleEng : this.state.lang === 'de' ? titleGer : this.state.lang === 'rs' ? titleSrb : null
    var tags = this.state.lang === 'uk' ? tagsEng : this.state.lang === 'de' ? tagsGer : this.state.lang === 'rs' ? tagsSrb : null
    return (<DocMeta tags={tags}>
              <div className='row'>
                {this.slider()}
                {this.state.lang === 'uk' ? this.opisEng() : this.state.lang === 'de' ? this.opisGer() : this.state.lang === 'rs' ? this.opisSrb() : null }
                {this.state.lang === 'rs' ? this.novosti() : null}
              </div>
            </DocMeta>)
  }
})

module.exports = Pocetna;



/** WEBPACK FOOTER **
 ** ./modules/components/App/Pocetna.js
 **/